export default __webpack_public_path__ + "static/media/cancellSendImage.589edf34.png";